import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'react-app-polyfill/jsdom';
import 'string.prototype.startswith';
import 'ie-array-find-polyfill';
import 'core-js/features/object/values';
import 'core-js/modules/es.object.values';

import React from 'react';
import ReactDOM from 'react-dom';

import './utils/i18n';

import configureStore from './store/configureStore';
import App from './components/App';
import { setBaseUrl, setWebCatalog } from './utils/http';
import rollbarInit from './utils/rollbar';
import { provideRequestInterceptors, provideResponseInterceptors } from './utils/httpInterceptors';

import './styles.sass';

if (process.env.NODE_ENV === 'production') {
    rollbarInit({
        token: '4bb342cfdc174f34ad3daf31fe6814ee',
        version: process.env.REACT_APP_VERSION,
        environment: window.location.host
    });

    window._version = {
        version: process.env.REACT_APP_VERSION
    };
}

setBaseUrl();
setWebCatalog();
provideRequestInterceptors();
provideResponseInterceptors();

const MOUNT_NODE = document.getElementById('root');
const store = configureStore();

ReactDOM.render(<App store={store} />, MOUNT_NODE);
